import { Button } from "react-bootstrap";
import { useReconcilePropertyBookingsMutation } from "../../services/bClientApi";


export default function ReconcilePropertyButton({ propertyId }: { propertyId: string }) {
    const [
        reconcilePropertyBookings,
        {
            isLoading: isReconcileLoading,
            // isSuccess: isReconcileSuccess,
            isError: isReconcileError,
            error: reconcileError
        },
    ] = useReconcilePropertyBookingsMutation();

    return (
        <>
            {isReconcileError && (<>{JSON.stringify(reconcileError)}<br /></>)}
            <Button
                onClick={async () => {
                    const reconciliationResults = await reconcilePropertyBookings(propertyId).unwrap()
                    console.log('Reconciliation Results:', reconciliationResults)
                }}
                disabled={isReconcileLoading}
                variant="secondary"
                size="sm"
            >
                {isReconcileLoading ? 'Reconciling...' : 'Reconcile Bookings'}
            </Button>
        </>
    )
}